<template>
  <div>
    <div class="row border-bottom mb-3">
      <div class="col">
        <h5>We have outlined our application process below. Should you have any questions please reach out to bhutan@etonhouse.edu.sg.</h5>
      </div>
    </div>

    <h5>Application Process</h5>
    All the below documents must be notarised <strong>or</strong> translated into English.

    <ol>
      <li>Child's Birth Certificate</li>
      <!-- <li>Child's Immigration document (Dependant Pass, In Principle of Approval Letter, Re-Entry Permit, LTVP, Student Pass)</li> -->
      <li>Child's passport & most recent passport-sized photograph (clear, digital photo)</li>
      <li>Child's parents passport & most recent passport-sized photograph (clear, digital photo)</li>
      <!-- <li>Child's parents immigration document (Employment Pass, Dependant Pass, In Principle of Approval Letter, NRIC, LTVP)</li> -->
      <li>Child's current and past (two years' full academic school reports)</li>
      <!-- <li>Child's vaccination records (Measles and Diphtheria are mandatory for children age 12 and below)</li> -->
      <li>Any medical, psychology reports and education evaluation reports (whichever is applicable)</li>
    </ol>
    <p>Please provide a copy of front-back copy of any immigration passes (whichever is applicable)</p>
    <hr />

    <h5>Application Review</h5>
    <p>
      Bhutan International School does not guarantee the placement of your child. Placement is subject to vacancies and the approval of the Academic Board. All
      students' applications are reviewed and assessed holistically by our Academic Board, and a student may be required to sit a pre-enrolment assessment test
      (charges apply) and/or interview before a place is offered.
    </p>
    <p>
      The Academic Board's final decision is irrevocable. In the event that the child's application has not been successful the application will be treated as
      withdrawn.
    </p>

    <hr />

    <h5>Application Outcome</h5>
    Successful applications will receive;
    <ul>
      <li>A Letter of Offer - confirming your specified commencement date and year level and should proceed to pay the non-refundable Enrolment Fee.</li>
      <li>
        A Letter of Conditional Offer - will have a condition included in their letter; the child is required to attend English as an Additional Language (EAL)
        Programme, Learning Support and specific monitoring of the child throughout the year/or period of time. (This is to ensure that we have resources in
        place to support each child). These programmes are chargeable at an additional cost.
      </li>
    </ul>
    Unsuccessful applications will receive;
    <ul>
      <li>
        A Letter of Rejection - unsuccessful applications would receive a letter notifying parents of the rejection. These are cases where the school may not be
        able to provide the level of support required for the student.
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ApfEbisSupportingDocument',
}
</script>
